export default __webpack_public_path__ + "static/media/landingPagePic1.8cbad022.JPG";